"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_svg_1 = require("react-native-svg");
const Error = (props) => {
    const { width, height, color } = props;
    return (react_1.default.createElement(react_native_svg_1.Svg, { width: width, height: height, viewBox: "0 0 24 24" },
        react_1.default.createElement(react_native_svg_1.G, { fill: "none", "fill-rule": "evenodd", opacity: ".8" },
            react_1.default.createElement(react_native_svg_1.Path, { fill: "none", d: "M0 0h24v24H0z" }),
            react_1.default.createElement(react_native_svg_1.Path, { d: "m19.119 17.1-6.6-11.4a.624.624 0 0 0-1.038 0l-6.6 11.4a.6.6 0 0 0 .519.9h13.2a.6.6 0 0 0 .519-.9zm-6.395-7.5-.284 3.96h-.88l-.267-3.96h1.43zM12 16.2a.88.88 0 1 1 0-1.76.88.88 0 0 1 0 1.76z", fill: color }))));
};
Error.defaultProps = {
    color: '#111111',
    width: 24,
    height: 24,
};
exports.default = react_1.default.memo(Error);
